export default function PollsPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📊 Encuestas
      </h1>
      <p style={{ color: '#888' }}>Gestión de encuestas pendiente de implementación.</p>
    </div>
  );
}
